import { Box, Heading, Text, Button, Flex, Badge, Icon } from "@chakra-ui/react";
import { Evento } from "../../services/models/Evento";
import { useNavigate } from "react-router-dom";
import { InfoIcon, CalendarIcon } from "@chakra-ui/icons";

interface EventoCardProps {
  evento: Evento;
}

const EventoCard = ({ evento }: EventoCardProps) => {
  const navigate = useNavigate();

  return (
    <Box
      bg="rgba(120, 165, 255, 0.9)"
      borderRadius="lg"
      boxShadow="0px 4px 12px rgba(0,0,0,0.25)"
      p={5}
      transition="all 0.3s"
      _hover={{
        transform: "translateY(-4px)",
        boxShadow: "0px 8px 20px rgba(0,0,0,0.35)",
      }}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      height="100%"
      minH="280px"
    >
      {/* Contenido superior */}
      <Box>
        <Heading size="md" color="black" mb={3} noOfLines={2} minH="3rem">
          {evento.titulo}
        </Heading>

        {evento.institucion_nombre && (
          <Badge colorScheme="blue" mb={2} fontSize="xs">
            {evento.institucion_nombre}
          </Badge>
        )}

        {/* Fechas - placeholder temporal */}
        <Flex align="center" mt={3} mb={2} color="gray.700">
          <Icon as={CalendarIcon} mr={2} />
          <Box>
            <Text fontSize="sm" fontWeight="semibold">
              Inicio: <Text as="span" fontWeight="normal">{evento.inicio ? new Date(evento.inicio).toLocaleDateString("es-ES") : "Por confirmar"}</Text>
            </Text>
            <Text fontSize="sm" fontWeight="semibold">
              Fin: <Text as="span" fontWeight="normal">{evento.fin ? new Date(evento.fin).toLocaleDateString("es-ES") : "Por confirmar"}</Text>
            </Text>
          </Box>
        </Flex>

        {evento.ubicacion && (
          <Text fontSize="sm" color="gray.800" mt={2}>
            📍 {evento.ubicacion}
          </Text>
        )}
      </Box>

      {/* Botón en la esquina inferior derecha */}
      <Flex justify="flex-end" mt={4}>
        <Button
          onClick={() => navigate(`/eventos/${evento.id}`)}
          size="sm"
          leftIcon={<InfoIcon />}
          bg="rgba(2, 54, 176, 0.9)"
          color="white"
          _hover={{ bg: "rgba(2, 54, 176, 1)" }}
        >
          Ver detalles
        </Button>
      </Flex>
    </Box>
  );
};

export default EventoCard;